import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation } from "react-apollo";
import { ASSIGN_USER_TO_ORGANIZATION } from "../../../graphql";
import Button from "../../UI/Button";
import OrganizationSelect from "../Select/Container";
import UserSelect from "../../User/Select/Container";

import {
  Rowz,
  Spacer
} from "../../../components/Layout/Layout";

class AssignUserForm extends React.Component {
  state = {
    organizationID: "",
    userID: ""
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  
  render() {
    return (
      <Mutation mutation={ASSIGN_USER_TO_ORGANIZATION}>
        {(assignUserToOrganization, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.assignUserToOrganization) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `User assigned to platform successfully`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  assignUserToOrganization({ variables: this.state });
                }}
              >
                <Spacer>
                  <Spacer>
                    <Rowz>
                      <OrganizationSelect type="PLATFORM" required value={this.state.organizationID} onChange={value=>this.handleInputChange("organizationID",value)}/>
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <UserSelect required value={this.state.userID} filterRole="CAREGIVER" onChange={value => this.handleInputChange("userID", value)} />
                    </Rowz>
                  </Spacer>

                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Submit
                    </Button>
                  </Spacer>
                </Spacer>
              </form>
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default AssignUserForm;